import React, { useState } from 'react';
import { useTheme } from '../context/ThemeContext';
import OperationalChat from './operational/OperationalChat';
import { SparklesIcon } from './icons';
import { useTranslation } from 'react-i18next';

export const OperationalChatButton: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { isDark } = useTheme();
  const { t } = useTranslation();

  const buttonBg = isDark
    ? 'bg-blue-600 hover:bg-blue-700'
    : 'bg-blue-500 hover:bg-blue-600';
  const overlayBg = 'bg-black/50';

  return (
    <div className="w-full h-full relative flex items-center justify-end">
      {/* Floating Button */}
      <button
        onClick={() => setIsOpen(true)}
        title={t('operational.title')}
        className={`fixed bottom-6 right-6 w-14 h-14 z-40 ${buttonBg} text-white rounded-full shadow-lg transition-all duration-200 flex items-center justify-center`}
        aria-label={t('operational.title')}
      >
        <SparklesIcon className="w-7 h-7" strokeWidth={1.75} />
      </button>

      {/* Modal Overlay & Container */}
      {isOpen && (
        <div
          className={`fixed inset-0 z-50 ${overlayBg} flex items-center justify-center p-4`}
          onClick={() => setIsOpen(false)}
          role="presentation"
        >
          {/* The chat owns its own header (title, session controls, close) */}
          <div
            className="w-full max-w-md h-[80vh] shadow-2xl rounded-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            <OperationalChat onClose={() => setIsOpen(false)} />
          </div>
        </div>
      )}
    </div>
  );
};

export default OperationalChatButton;
